import i18n from 'i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// Normalize language code (e.g., en-GB -> en, en-US -> en)
const normalizeLanguage = (lng) => {
    if (!lng) return 'tr';
    const normalized = lng.toLowerCase().split('-')[0];
    const supportedLngs = ["tr", "en", "de", "el", "bg", "ru"];
    return supportedLngs.includes(normalized) ? normalized : 'tr';
};

// Get initial language from localStorage or default to Turkish
const getInitialLanguage = () => {
    const stored = localStorage.getItem('i18nextLng');
    if (stored) {
        return normalizeLanguage(stored);
    }
    // If no stored language, check navigator but normalize it
    if (typeof navigator !== 'undefined' && navigator.language) {
        return normalizeLanguage(navigator.language);
    }
    return 'tr';
};

const initialLanguage = getInitialLanguage();

i18n
    // load translation using http -> see /public/locales
    // learn more: https://github.com/i18next/i18next-http-backend
    .use(Backend)
    // detect user language
    // learn more: https://github.com/i18next/i18next-browser-languageDetector
    .use(LanguageDetector)
    // pass the i18n instance to react-i18next.
    .use(initReactI18next)
    // init i18next
    // for all options read: https://www.i18next.com/overview/configuration-options
    .init({
        fallbackLng: "tr",
        lng: initialLanguage,
        supportedLngs: ["tr", "en", "de", "el", "bg", "ru"],
        debug: false,
        interpolation: {
            escapeValue: false, // not needed for react as it escapes by default
        },
        backend: {
            loadPath: `${process.env.PUBLIC_URL || ''}/locales/{{lng}}/translation.json`,
        },
        detection: {
            order: ['localStorage', 'navigator'],
            caches: ['localStorage'],
            lookupLocalStorage: 'i18nextLng',
            // Normalize detected language before caching
            convertDetectedLanguage: (lng) => {
                return normalizeLanguage(lng);
            },
        },
    });

// Listen for language changes and normalize them
i18n.on('languageChanged', (lng) => {
    const normalized = normalizeLanguage(lng);
    if (normalized !== lng) {
        i18n.changeLanguage(normalized);
    }
    // Ensure localStorage has the normalized language
    localStorage.setItem('i18nextLng', normalized);
});

export default i18n;